import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const dividerStyling: AbgSxProps = { margin: '20px 24px 16px 24px' };
export const accordionStyling: AbgSxProps = {
  marginBottom: '16px',
  '&.Custom-Mui-Accordion-class.MuiPaper-root': {
    borderRadius: 'initial',
    width: '100%',
    borderBottom: 0,
    marginTop: 0,
    boxShadow: 'none',
    '&:last-child': { marginBottom: '20px' },
  },
  '&::before': {
    display: 'none',
  },
};

export const RateTermsStyling: AbgSxProps = {
  textDecoration: 'underline',
  color: paletteBase.neutral400,
  paddingTop: '4px',
  lineHeight: '12px !important',
};

export const RateTermsLabelStyling: AbgSxProps = {
  color: paletteBase.neutral400,
  lineHeight: '12px !important',
  margin: {
    xs: '0',
    sm: '12px 0 8px 0',
  },
  padding: {
    xs: '4px 0px',
    sm: '4px 24px',
  },
};

export const RateTermsSummaryStyling: AbgSxProps = {
  fontSize: '12px',
};
